import React from 'react';

const CodeMappingField = ({ prefix, content, borderTop = false }) => {
    let classes = 'col-large py-3 border-dark border-right';
    if (borderTop) classes += ' border-top';
    return (
        <td className={classes}>
            <b>{prefix}</b>
            &nbsp;
            {content}
        </td>
    );
};

export default CodeMappingField;
